module.exports = __webpack_public_path__ + "img/Pre-reception@2x.5d18bff7.png";